type Section = [string, string];

export default function LegalBody({
  title,
  updated,
  sections,
}: {
  title: string;
  updated: string;
  sections: Section[];
}) {
  return (
    <article className="max-w-3xl mx-auto px-6 py-14">
      <header className="mb-10">
        <h1 className="text-4xl font-extrabold tracking-tight mb-2">
          {title}
        </h1>
        <div className="text-sm text-textMuted">Son güncelleme: {updated}</div>
      </header>

      <div className="card divide-y divide-stroke/70">
        {sections.map(([heading, body]) => (
          <section key={heading} className="p-6">
            <h2 className="font-extrabold text-lg mb-2">{heading}</h2>
            <p className="text-textSecondary leading-relaxed whitespace-pre-line">
              {body}
            </p>
          </section>
        ))}
      </div>

      <footer className="text-sm text-textMuted mt-8">
        Bu metin uygulama binary'sinde de birebir yer alır. Uyuşmazlık
        durumunda güncel olan WEB sürümüdür.
      </footer>
    </article>
  );
}
